// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__tLFlt","label":"CategoryService_label__mpHzn","location":"CategoryService_location__2yxSq"};